import React from 'react';
import { Link } from 'react-router-dom';
import { useDashboardData } from './Dashboard';
import { formatPrice } from '../../utils/formatHelper';
import InfoTooltip from './InfoTooltip';

const PendingOrders = () => {
  const { deliveries: data } = useDashboardData();

  const orders = data?.pendingOrders || [];

  const statusBadge = (status) => {
    const map = {
      PENDING: { label: 'Bekliyor', cls: 'bg-warning text-dark' },
      PROCESSING: { label: 'İşleniyor', cls: 'bg-info text-dark' }
    };
    const s = map[status] || { label: status, cls: 'bg-secondary' };
    return <span className={`badge ${s.cls}`} style={{ fontSize: '0.65rem' }}>{s.label}</span>;
  };

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-hourglass-half me-2" style={{ color: '#f59e0b' }}></i>
          İşlem Bekleyen Siparişler
          <InfoTooltip text="PENDING veya PROCESSING durumundaki siparişler. 'Bekleme' sütunu siparişin kaç gündür işlenmeden beklediğini gösterir." />
        </div>
        <Link to="/admin/orders?status=PENDING" className="detail-panel-link">
          Tümü →
        </Link>
      </div>
      <div className="detail-panel-body" style={{ padding: 0 }}>
        {!data ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : orders.length === 0 ? (
          <div className="py-4 text-center text-muted">
            <i className="fas fa-check-circle fa-2x mb-2 d-block" style={{ color: '#10b981' }}></i>
            <span className="small">Bekleyen sipariş yok</span>
          </div>
        ) : (
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Sipariş</th>
                <th>Müşteri</th>
                <th>Bekleme</th>
                <th>Tutar</th>
                <th>Durum</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id}>
                  <td>
                    <Link
                      to={`/admin/orders?orderId=${encodeURIComponent(order.id)}`}
                      className="text-decoration-none fw-semibold"
                      style={{ color: 'var(--admin-primary)' }}
                    >
                      #{order.orderNumber || order.id}
                    </Link>
                  </td>
                  <td className="text-truncate" style={{ maxWidth: '120px' }}>{order.customerName || '—'}</td>
                  <td>
                    <span className={order.waitingDays >= 3 ? 'text-danger fw-bold' : ''}>
                      {order.waitingDays} gün
                    </span>
                  </td>
                  <td>{formatPrice(order.amount)}</td>
                  <td>{statusBadge(order.originalStatus)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default PendingOrders;
